module.exports = __webpack_public_path__ + "static/media/icon_9.714195a6.svg";